import { useLoadScript } from "@react-google-maps/api";

const GOOGLE_MAPS_LIBRARIES: "places"[] = ["places"];

/**
 * Un único punto de carga del script de Google Maps JS (mapa + Places API New) para
 * toda la app. useLoadScript deduplica si se llama desde varios componentes montados
 * a la vez, pero siempre con la misma config (libraries) para no pisarse.
 */
export function useGoogleMapsLoader() {
  const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY as string | undefined;
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: apiKey ?? "",
    libraries: GOOGLE_MAPS_LIBRARIES,
  });
  return {
    isLoaded: Boolean(apiKey) && isLoaded,
    loadError,
    apiKeyConfigured: Boolean(apiKey),
  };
}
